module.exports = __webpack_public_path__ + "img/xixi.913e2f3d.gif";